import type { BidEntry } from '../data/mockLots';
import { BidderAvatar } from './BidderPill';

function formatRelative(ts: number, now: number): string {
  const diff = Math.max(0, Math.floor((now - ts) / 1000));
  if (diff < 60) return `${diff}s`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ${diff % 60}s`;
  const h = Math.floor(diff / 3600);
  const m = Math.floor((diff % 3600) / 60);
  return `${h}h ${m}m`;
}

type Props = {
  entry: BidEntry;
  isLatest: boolean;
  now: number;
  count?: number;
};

export function BidHistoryRow({ entry, isLatest, now, count }: Props) {
  const { bidder, ts, price } = entry;
  const ago = formatRelative(ts, now);

  const inner = (
    <>
      <span className="font-mono text-[10px] tabular-nums text-fg-muted w-12 shrink-0">
        −{ago}
      </span>
      <BidderAvatar bidder={bidder} size="xs" />
      <span className="font-medium text-[12px] text-fg truncate min-w-0 flex-1">
        {bidder.firstName}
        {bidder.username && (
          <span className="text-fg-dim font-mono text-[10px] ml-1">@{bidder.username}</span>
        )}
      </span>
      {typeof count === 'number' && (
        <span
          className={`font-mono text-[10px] tabular-nums px-1.5 py-[1px] border shrink-0 ${
            count === 1
              ? 'text-fg-muted border-fg-dim/40 bg-fg-dim/5'
              : count >= 10
                ? 'text-accent border-accent/40 bg-accent/5'
                : 'text-primary border-primary/30 bg-primary/5'
          }`}
        >
          ×{count}
        </span>
      )}
      <span className="font-mono text-[11px] tabular-nums text-fg shrink-0 w-14 text-right">
        ${price.toFixed(2)}
      </span>
    </>
  );

  const baseClass = `flex items-center gap-2 px-3 h-9 ${isLatest ? 'bg-primary/5 border-l-[3px] border-primary' : 'border-l-[3px] border-transparent'}`;

  if (bidder.username) {
    return (
      <a
        href={`https://t.me/${bidder.username}`}
        target="_blank"
        rel="noreferrer"
        className={`${baseClass} hover:bg-bg-elev/60 transition-colors`}
      >
        {inner}
      </a>
    );
  }

  return (
    <div
      className={`${baseClass} cursor-default`}
      title="hidden username — say hi in @SkinStepChat"
    >
      {inner}
    </div>
  );
}
